import MessageService from '../../services/MessageService'

const state = () => ({
    loadingMessages: false,
    message: null,
    /** Lista de mensagens para a tela List_Messages (todas conversas, via fetchMessagesByUsers) */
    messages: [],
    total: 0,
    pages: 0,
    page: 1,
    /** Mensagens da conversa aberta no chat (sidebar ou aba no FormUser, via fetchMessages) */
    conversationMessages: [],
    conversationPage: 1,
    conversationPages: 0,
    conversationTotal: 0,
    hasMoreOlder: true,
    loadingConversation: false,
    show_modal_new_message: false
})

const mutations = {
    SET_MESSAGE: (state, payload) => {
        state.message = payload
    },
    SET_MESSAGES: (state, payload) => {
        if (payload.pageNumber == 1) {
            state.messages = payload.itens
        } else {
            state.messages = [...state.messages, ...payload.itens]
        }
        state.page = payload.pageNumber
        state.pages = payload.pages
        state.total = payload.total
    },
    SET_CONVERSATION_MESSAGES: (state, payload) => {
        if (payload.pageNumber == 1) {
            state.conversationMessages = payload.itens || []
        } else {
            state.conversationMessages = [...(payload.itens || []), ...state.conversationMessages]
        }
        state.conversationPage = payload.pageNumber
        state.conversationPages = payload.pages
        state.conversationTotal = payload.total
        state.hasMoreOlder = (payload.itens?.length || 0) >= 12
    },
    /** Inserir mensagens mais antigas no início (carregar mais) */
    PREPEND_CONVERSATION_MESSAGES: (state, payload) => {
        state.conversationMessages = [...(payload.itens || []), ...state.conversationMessages]
        if (payload.pages != null) state.conversationPages = payload.pages
        if (payload.total != null) state.conversationTotal = payload.total
        state.hasMoreOlder = (payload.itens?.length || 0) >= 12
    },
    /** Inserir mensagens novas no final (polling) */
    APPEND_CONVERSATION_MESSAGES: (state, payload) => {
        state.conversationMessages = [...state.conversationMessages, ...(payload.itens || [])]
    },
    SET_LOADING_MESSAGES: (state, payload) => {
        state.loadingMessages = payload
    },
    SET_LOADING_CONVERSATION: (state, payload) => {
        state.loadingConversation = payload
    },
    SET_SHOW_MODAL_MESSAGE: (state, payload) => {
        state.show_modal_new_message = payload
    },
}

const actions = {
    async fetchMessage({commit}, id){
        try{
            commit('SET_LOADING_MESSAGES', true)
            const response = await MessageService.getOne(id);
            commit('SET_MESSAGE', response.data)
            commit('SET_LOADING_MESSAGES', false)
        } catch (error) {
            commit('SET_LOADING_MESSAGES', false);
            // commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchMessages({commit}, params = {}){
        try{
            const { keyword = '', pageNumber = 1, pageSize = 12, order = { name: 'createdAt', column: 'createdAt', sort: 'ASC' }, UserId = '', numberPhone = '', senderPhone = '', recipientId = '', beforeId = null, afterId = null, silentRefresh = false } = params;
            const isPolling = !!afterId || silentRefresh;
            if (!isPolling) commit('SET_LOADING_CONVERSATION', true);
            const response = await MessageService.get(keyword, pageNumber, pageSize, order, UserId, numberPhone, senderPhone, recipientId, beforeId, afterId);
            if (beforeId) {
                commit('PREPEND_CONVERSATION_MESSAGES', response.data);
            } else if (afterId) {
                commit('APPEND_CONVERSATION_MESSAGES', response.data);
            } else {
                commit('SET_CONVERSATION_MESSAGES', response.data);
            }
            commit('SET_LOADING_CONVERSATION', false);
        } catch (error) {
            commit('SET_LOADING_CONVERSATION', false);
            if (!params.afterId && !params.silentRefresh) {
                commit('LOG_USER_OUT');
                commit('SET_ALERT', {
                    heading: 'error',
                    message: error.response?.data?.message || 'Falha ao carregar mensagens.'
                });
            }
        }
    },
    async fetchMessagesByUsers({commit}, params = {}){
        try{
            commit('SET_LOADING_MESSAGES', true)
            const { keyword = '', pageNumber = 1, pageSize = 12, order = { name: 'createdAt', column: 'sentAt', sort: 'DESC' } , UserId = '', numberPhone = '', senderPhone = '', recipientId = '' } = params;
            const response = await MessageService.getByUser(keyword, pageNumber, pageSize, order, UserId, numberPhone, senderPhone, recipientId);
            commit('SET_MESSAGES', response.data)
            commit('SET_LOADING_MESSAGES', false)
        } catch (error) {
            commit('SET_LOADING_MESSAGES', false);
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async createMessage({commit}, data){
        try{
            commit('SET_LOADING_MESSAGES', true)
            const response = await MessageService.create(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_SHOW_MODAL_MESSAGE', false)
            commit('SET_LOADING_MESSAGES', false)
        } catch (error) {
            commit('SET_LOADING_MESSAGES', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async updadeMessage({commit}, data){
        try{
            commit('SET_LOADING_MESSAGES', true)
            const response = await MessageService.update(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_LOADING_MESSAGES', false)
        } catch (error) {
            commit('SET_LOADING_MESSAGES', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
}

const getters = {
    getMessage: state => state.message,
    getMessages: state => state.messages,
    getConversationMessages: state => state.conversationMessages,
    getLoadingMessage: state => state.loadingMessages,
    getLoadingConversation: state => state.loadingConversation,
    getConversationPage: state => state.conversationPage,
    getConversationPages: state => state.conversationPages,
    getHasMoreOlder: state => state.hasMoreOlder,
    getShowModalNewMessage: state => state.show_modal_new_message
}

export default {
    state,
    getters,
    mutations,
    actions
};